import axios from "axios";

class ContractRequestService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Leonel Contreras
   * @description Handle event to get the contractBullet from the microservice hibou.legal in A3cloud
   * @date 20-07-2020
   * @param {Number} questionnaireId
   * @param {String} token
   * @returns {Object}
   * @memberof ContractService
   */

  async getQuestionnaireById(questionnaireId, token) {
    let response = axios.get(
      `${this.apiUrl}/contractors?id=${questionnaireId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  }

  async getContractorsByClientId(clientId, token) {
    let response = axios.get(
      `${this.apiUrl}/contractors?clientId=${clientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  }

  async createClientContractContractors(body, token) {
    let response = axios.post(
      `${this.apiUrl}/client-contract-contractors`,
      {
        name: body.name,
        description: body.description,
        questionnaireId: body.questionnaireId,
        clientContractStatusId: body.clientContractStatusId,
        userCreatorEmail: body.userCreatorEmail,
        userLawyerId: body.userLawyerId,
        contractorList: body.contractorList,
        existClientContract: body.existClientContract,
        timezone: body.timezone
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  }

  async createContractor(body, token) {
    let response = await axios.post(
      `${this.apiUrl}/contractor`,
      {
        email: body.email,
        emailCreator: body.emailCreator,
        name: body.name,
        nameContract: body.nameContract,
        limitDate: body.limitDate,
        notes: body.notes,
        description: body.description,
        questionnaireId: body.questionnaireId,
        clientContractStatusId: body.clientContractStatusId,
        userLawyerId: body.userLawyerId,
        contractCreatedId: body.contractCreatedId,
        isRepse: body.isRepse,
        onlyCreateContractor: body.onlyCreateContractor,
        classifierId: body.classifierId,
        companyId: body.companyId,
        contractorPersonType: body.contractorPersonType,
        timezone: body.timezone
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  }
}

export { ContractRequestService as default };
